<template>
  <div>

    <div class="modal fade"
         id="modal-create-purchase"
         tabindex="-1"
         role="dialog"
         data-bs-backdrop="static"
         data-bs-keyboard="false">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white d-flex justify-content-between align-items-center">
            <h5 class="modal-title mb-0">
              {{ purchase ? 'Modifier une Entrée' : 'Nouvelle Entrée' }}
              <span
                  v-if="purchase"
                  class="badge ms-3"
                  :class="statusBadgeClass"
              >
    Statut : {{ purchase.status }}
  </span>
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
          </div>

          <div class="modal-body">
            <ValidationObserver ref="observer" v-slot="{ invalid }">
              <form @submit.prevent="submitForm">
                <!-- Sélection produit -->
                <div class="form-row align-items-end" v-if="!isReadOnly">
                  <div class="form-group col-md-4">
                    <label>Produit</label>
                    <multi-select
                        :options="allProducts"
                        v-model="selectedProduct"
                        track-by="code"
                        label="name"
                        placeholder="Choisir un produit"
                        :custom-label="o => `${o.name} - ${o.code}`"
                        :searchable="true"
                        style="min-width: 250px"
                        :disabled="isReadOnly"
                    >
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.name }} ({{ option.code }})</strong>
                      </template>
                      <span slot="noOptions"><strong>Liste vide</strong></span>
                      <span slot="noResult"><strong>Aucun résultat</strong></span>
                    </multi-select>
                  </div>

                  <div class="form-group col-md-2">
                    <label>Quantité</label>
                    <input type="number" v-model="formLine.quantity" class="form-control" min="1" :disabled="isReadOnly" />
                  </div>

                  <div class="form-group col-md-2">
                    <label>Prix Unitaire (€)</label>
                    <input type="number" v-model="formLine.unitPrice" class="form-control" min="0" step="0.01" :disabled="isReadOnly" />
                  </div>

                  <div class="form-group col-md-2">
                    <button class="btn btn-primary" type="button" @click="addProductLine" :disabled="isReadOnly">
                      <i class="fe fe-plus"></i> Ajouter
                    </button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xl-8">
                    <div class="card cart">
                      <div class="card-header">
                        <h3 class="card-title">Items</h3>
                      </div>
                      <div class="card-body">
                        <div class="table-responsive" v-if="payload.products.length">
                          <table class="table table-bordered table-vcenter">
                            <thead>
                            <tr class="border-top">
                              <th>Product</th>
                              <th>Title</th>
                              <th>Price</th>
                              <th>Quantity</th>
                              <th>Subtotal</th>
                              <th v-if="!isReadOnly">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(line, index) in payload.products" :key="index">
                              <td>
                                <div class="text-center">
                                  {{ line.productCode }}
                                </div>
                              </td>
                              <td>{{ line.productName }}</td>
                              <td class="fw-bold">{{ line.unitPrice.toFixed(2) }}</td>
                              <td>
                                <div class="handle-counter" id="handleCounter1">
                                  <button type="button" class="counter-minus btn btn-white lh-2 shadow-none"  @click="decrementQty(index)" :disabled="line.quantity <= 1 || isReadOnly" >
                                    <i class="fe fe-minus text-muted"></i>
                                  </button>
                                  <input type="text" :value="line.quantity" class="qty" readonly>
                                  <button type="button" class="counter-plus btn btn-white lh-2 shadow-none" @click="incrementQty(index)" :disabled="isReadOnly">
                                    <i class="fe fe-plus text-muted"></i>
                                  </button>
                                </div>
                              </td>
                              <td>{{ (line.quantity * line.unitPrice).toFixed(2) }}</td>
                              <td>
                                <div class=" d-flex g-2" v-if="!isReadOnly">
                                  <a class="btn text-danger bg-danger-transparent btn-icon py-1" @click="removeLine(index)" data-bs-toggle="tooltip" data-bs-original-title="Delete"><span class="bi bi-trash fs-16"></span></a>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="card-footer">
                        <div class="row">
                          <div class="col-md-6 col-sm-6">

                          </div>
                          <div class="col-md-6 col-sm-6 text-end"><a href="javascript:void(0)" class="btn btn-default disabled btn-md">Update Cart</a></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 col-xl-4 col-sm-12 col-md-12" v-if="payload.products.length">
                    <div class="card">
                      <div class="card-header">
                        <div class="card-title">Purchse Totals</div>
                      </div>
                      <div class="card-body py-2">
                        <div class="table-responsive">
                          <table class="table table-borderless text-nowrap mb-0">
                            <tbody>
                            <tr>
                              <td class="text-start">Sub Total</td>
                              <td class="text-end"><span class="fw-bold  ms-auto">{{ totalAmount.toFixed(2) }}</span></td>
                            </tr>
                            <tr>
                              <td class="text-start">Additional Discount</td>
                              <td class="text-end"><span class="fw-bold text-success">0</span></td>
                            </tr>
                            <tr>
                              <td class="text-start">Delivery Charges</td>
                              <td class="text-end"><span class="fw-bold text-green">0 (Free)</span></td>
                            </tr>
                            <tr>
                              <td class="text-start">Tax</td>
                              <td class="text-end"><span class="fw-bold text-danger">0</span></td>
                            </tr>
                            <tr>
                              <td class="text-start fs-18">Total Bill</td>
                              <td class="text-end"><span class="ms-2 fw-bold fs-23">{{ totalAmount.toFixed(2) }}</span></td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <!-- Boutons -->
                <!--              <div class="text-end mt-4 d-flex justify-content-between align-items-center">-->
                <!--                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>-->

                <!--                <div class="btn-group" v-if="!isReadOnly">-->
                <!--                  <button-->
                <!--                      v-for="op in availableOperations"-->
                <!--                      :key="op"-->
                <!--                      type="button"-->
                <!--                      class="btn"-->
                <!--                      :class="op === selectedOperation ? 'btn-primary' : 'btn-outline-primary'"-->
                <!--                      :disabled="invalid || payload.products.length === 0"-->
                <!--                      @click="selectedOperation = op; submitForm()"-->
                <!--                  >-->
                <!--                    {{ op }}-->
                <!--                  </button>-->
                <!--                </div>-->
                <!--              </div>-->

                <!-- Boutons -->
                <div class="text-end mt-4 d-flex justify-content-between align-items-center">
                  <button type="button" class="btn btn-default" data-bs-dismiss="modal">Fermer</button>

                  <div class="btn-group">
                    <!-- Boutons dynamiques (STORE, REGISTER...) si modifiable -->
                    <template v-if="!isReadOnly">
                      <button
                          v-for="op in availableOperations"
                          :key="op"
                          type="button"
                          class="btn"
                          :class="op === selectedOperation ? 'btn-primary' : 'btn-outline-primary'"
                          :disabled="invalid || payload.products.length === 0"
                          @click="selectedOperation = op; submitForm()"
                      >
                        {{ op }}
                      </button>
                    </template>

                    <!-- Boutons Valider / Rejeter visibles en lecture seule uniquement si statut REGISTERED -->
                    <template v-else-if="purchase && purchase.status === 'REGISTERED'">
                      <button
                          class="btn btn-success"
                          type="button"
                          @click="validatePurchase"
                          title="Valider définitivement l'achat"
                          data-bs-toggle="tooltip"
                      >
                        <i class="fe fe-check me-1"></i> Valider
                      </button>
                      <button
                          class="btn btn-danger"
                          type="button"
                          @click="rejectPurchase"
                          title="Rejeter l'achat avec un motif"
                          data-bs-toggle="tooltip"
                      >
                        <i class="fe fe-x me-1"></i> Rejeter
                      </button>
                    </template>
                  </div>
                </div>


              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <template v-if="purchase">
      <modal-reject-comment
          ref="modalReject"
          :reference="purchase.reference"
          :entity-id="purchase.id"
          title="Rejet de l'achat"
          confirm-button-text="Rejeter l'achat"
          placeholder="Veuillez préciser le motif du rejet"
          @submit="handleReject"
      >
        <template #context>
          <p class="mb-2">Référence : <strong>{{ purchase.reference }}</strong></p>
          <p class="mb-2">Montant total : <strong>{{ totalAmount.toFixed(2) }} €</strong></p>
        </template>
      </modal-reject-comment>
    </template>
  </div>

</template>
<script>
  import GenericSelect from "../GenericSelect.vue";
  import { confirmAction, showValidationErrors } from "../../helpers/helpers";
  import ModalRejectComment from "./ModalRejectComment.vue";

  export default {
    name: "ModalCreatePurchase",
    components: {ModalRejectComment, GenericSelect },
    props: {
      purchase: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        payload: {
          products: [],
          totalAmount: 0,
        },
        selectedProduct: null,
        formLine: {
          quantity: 1,
          unitPrice: 0,
        },
        allProducts: [],
        availableOperations: [],
        selectedOperation: 'REGISTER',
      };
    },
    computed: {
      totalAmount() {
        return this.payload.products.reduce((sum, line) => sum + (line.unitPrice * line.quantity), 0);
      },
      isReadOnly() {
        return this.purchase && ['VALIDATED', 'REJECTED', 'REGISTERED'].includes(this.purchase.status);
      },
      statusBadgeClass() {
        switch (this.purchase?.status) {
          case 'VALIDATED':
            return 'bg-success text-white';
          case 'REJECTED':
            return 'bg-danger text-white';
          case 'REGISTERED':
            return 'bg-warning text-dark';
          case 'STORED':
            return 'bg-secondary text-white';
          default:
            return 'bg-light text-dark';
        }
      }
    },

    watch: {
      purchase: {
        immediate: true,
        handler(newVal) {
          if (newVal?.id) {
            this.loadPurchase(newVal.id);
          } else {
            this.payload = { products: [], totalAmount: 0 };
            this.availableOperations = ['STORE', 'REGISTER'];
            this.selectedOperation = 'REGISTER';
          }
        }
      }
    },


    methods: {
      async rejectPurchase() {
        const { confirmed } = await confirmAction('reject');
        if (!confirmed) return;

        // Ouvre la modal de rejet
        this.$refs.modalReject.open();
      },

      async handleReject({ commentaire, reference }) {
        this.$loading(true);
        this.$http.post(`/purchases/${this.purchase.id}/REJECT`, {
          commentaire,
          reference
        })
            .then(() => {
              swal('Succès', 'Achat rejeté avec succès.', 'success');
              this.$emit('refresh');
              $('#modal-create-purchase').modal('hide');
            })
            .catch(showValidationErrors)
            .finally(() => this.$loading(false));
      },
      async validatePurchase() {
        const confirmed = await confirmAction('validate');
        if (!confirmed) return;

        this.$loading(true);
        this.$http.put(`/purchases/${this.purchase.id}/VALIDATE`)
            .then(() => {
              swal('Succès', 'Achat validé avec succès.', 'success');
              this.$emit('refresh');
              $('#modal-create-purchase').modal('hide');
            })
            .catch(showValidationErrors)
            .finally(() => this.$loading(false));
      },




      incrementQty(index) {
        this.payload.products[index].quantity += 1;
      },

      decrementQty(index) {
        if (this.payload.products[index].quantity > 1) {
          this.payload.products[index].quantity -= 1;
        }
      },

      loadProducts() {
        this.$loading(true);
        this.$http.get("/products")
            .then(({ data }) => {
              this.allProducts = data;
            })
            .finally(() => this.$loading(false));
      },

      async loadPurchase(id) {
        this.$loading(true);
        try {
          const [purchaseRes, linesRes, opsRes] = await Promise.all([
            this.$http.get(`/purchases/${id}`),
            this.$http.get(`/purchase-lines/purchase/${id}`),
            this.$http.get(`/purchases/${id}/operations`)
          ]);

          this.payload.products = linesRes.data.map(line => ({
            id: line.id,
            productCode: line.productCode,
            productName: line.productName,
            quantity: line.quantity,
            unitPrice: line.unitPrice,
            purchaseId: id,
          }));

          this.payload.totalAmount = this.totalAmount;
          this.availableOperations = opsRes.data;
          this.selectedOperation = this.availableOperations[0] || null;
        } catch (e) {
          swal('Erreur', 'Impossible de charger les données de l’achat.', 'error');
        } finally {
          this.$loading(false);
        }
      },


      addProductLine() {
        if (!this.selectedProduct || !this.selectedProduct.code || this.formLine.quantity <= 0 || this.formLine.unitPrice < 0) {
          swal('Erreur', 'Veuillez renseigner un produit, une quantité et un prix unitaire valides.', 'warning');
          return;
        }

        const exists = this.payload.products.some(p => p.productCode === this.selectedProduct.code);
        if (exists) {
          swal('Erreur', 'Ce produit est déjà dans la liste.', 'warning');
          return;
        }

        this.payload.products.push({
          id: null,
          productCode: this.selectedProduct.code,
          productName: this.selectedProduct.name,
          description: this.selectedProduct.description,
          quantity: Number(this.formLine.quantity),
          unitPrice: Number(this.formLine.unitPrice),
          purchaseId: this.purchase?.id ?? null,
        });

        this.selectedProduct = null;
        this.formLine = { quantity: 1, unitPrice: 0 };
      },

      removeLine(index) {
        this.payload.products.splice(index, 1);
      },

      async submitForm() {
        if (this.isReadOnly) {
          console.warn("Formulaire readonly, soumission désactivée.");
          return;
        }
        const confirmed = await confirmAction(this.purchase ? 'update' : this.selectedOperation.toLowerCase());
        if (!confirmed) return;

        this.payload.totalAmount = this.totalAmount;
        this.$loading(true);

        const url = this.purchase
            ? `/purchases/${this.purchase.id}`
            : `/purchases/${this.selectedOperation.toUpperCase()}`;

        const method = this.purchase ? this.$http.put : this.$http.post;

        method(url, this.payload)
            .then(() => {
              swal('Succès', `Achat ${this.purchase ? 'modifié' : 'créé'} avec succès`, 'success');
              this.$emit('refresh');
              $('#modal-create-purchase').modal('hide');
            })
            .catch(showValidationErrors)
            .finally(() => {
              this.$loading(false);
            });
      },
    },
    created() {
      this.loadProducts();
    },
    mounted() {
      this.loadProducts();
      setTimeout(() => {
        const tooltips = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltips.forEach(el => new bootstrap.Tooltip(el));
      }, 300);
    }
  };
</script>
